import { Outlet } from 'react-router-dom';
import {
  IconNavPencilSquare,
  IconNavQuestionMarkCircle,
} from '../../components/icons';
import { AppShellGrid, type NavEntry } from '../../components/Sidebar';
import { useDict } from '../../i18n/dictionary';
import { useAppCrumb } from '../../layouts/AppLayout';
import { brainDict } from './i18n';

export function BrainLayout() {
  const t = useDict(brainDict);
  useAppCrumb('brain', t.appName, '/brain');
  const nav: NavEntry[] = [
    {
      key: 'ask',
      href: '/brain',
      label: t.ask,
      icon: IconNavQuestionMarkCircle,
      end: true,
    },
    {
      key: 'notes',
      href: '/brain/notes',
      label: t.notes,
      icon: IconNavPencilSquare,
    },
  ];
  return (
    <AppShellGrid items={nav}>
      <Outlet />
    </AppShellGrid>
  );
}
